
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SpecialFeatureCard',
  props: {
    image: {
      type: String,
      default: require('@/assets/images/common/noimg.jpg')
    },
    description: String,
    url: String,
    path: String,
    showPr: {
      type: Boolean,
      default: false
    }
  }
})
